import { Avatar } from "@admin/components/atoms/Avatar";
import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import { useCurrentUserGroups } from "@admin/hooks/useCurrentUserGroups";
import { CompanyLocation } from "@enos-monorepo/lib";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { ActivateLocationModal, EditLocationModal } from "./Modals";

interface InactiveLocationsProps {
  companyId: string;
  locations?: CompanyLocation[];
  isPending?: boolean;
}
export function InactiveLocations({
  companyId,
  locations,
  isPending,
}: InactiveLocationsProps) {
  const { t } = useTranslation();
  const { isSuperAdmin } = useCurrentUserGroups();
  const [selectedLocation, setSelectedLocation] = useState<CompanyLocation>();
  const [isActivateLocationModalOpen, setActivateLocationModalOpen] =
    useState(false);
  const [isEditLocationModalOpen, setIsEditLocationModalOpen] = useState(false);

  const columns: DataTableColumn<CompanyLocation>[] = useMemo(
    () => [
      {
        header: t("common.Name"),
        accessorKey: "name",
        cell: ({ row }) => (
          <div className="flex items-center gap-2.5">
            <Avatar alt={row.original.name} src={row.original.avatarPhoto} />
            <button className="text-sm font-medium text-gray-900 hover:text-primary-active">
              <div>{row.original.name}</div>
            </button>
          </div>
        ),
      },
      {
        header: t("common.Actions"),
        size: 110,
        cell: () => (
          <div className="flex justify-center">
            <button
              onClick={() => setIsEditLocationModalOpen(true)}
              className="btn btn-sm btn-icon btn-clear btn-primary"
            >
              <i className="ki-filled ki-notepad-edit"></i>
            </button>
            {isSuperAdmin && (
              <button
                className="btn btn-sm btn-icon btn-clear btn-success"
                onClick={() => setActivateLocationModalOpen(true)}
              >
                <i className="ki-filled ki-left-square"></i>
              </button>
            )}
          </div>
        ),
      },
    ],
    [isSuperAdmin, t],
  );

  return (
    <div className="card card-grid min-w-full">
      <DataTable
        loading={isPending}
        data={locations}
        columns={columns}
        title={t("location.Inactive Locations")}
        onRowClick={setSelectedLocation}
      />
      <ActivateLocationModal
        open={isActivateLocationModalOpen}
        onClose={() => setActivateLocationModalOpen(false)}
        locationId={selectedLocation?.id ?? ""}
        locationName={selectedLocation?.name ?? ""}
      />
      <EditLocationModal
        companyId={companyId}
        open={isEditLocationModalOpen}
        onClose={() => setIsEditLocationModalOpen(false)}
        companyLocation={selectedLocation}
      />
    </div>
  );
}
